export interface RoleItem {
  label: string;
  value: string;
}

export const availableRolesList: RoleItem[] = [
  {
    label: "Global Administrator",
    value: "Global Administrator",
  },
  {
    label: "Administrator",
    value: "Administrator",
  },
  {
    label: "Editor",
    value: "Editor",
  },
  {
    label: "Viewer",
    value: "Viewer",
  },
  {
    label: "Billing Manager",
    value: "Billing Manager",
  },
  {
    label: "Security Manager",
    value: "Security Manager",
  },
  {
    label: "Auditor",
    value: "Auditor",
  },
];

